import { render, staticRenderFns } from "./Features.vue?vue&type=template&id=1e7d819e&scoped=true"
import script from "./Features.vue?vue&type=script&lang=js"
export * from "./Features.vue?vue&type=script&lang=js"
import style0 from "./Features.vue?vue&type=style&index=0&id=1e7d819e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e7d819e",
  null
  
)

export default component.exports